<template>
  <div class="signIn" style="background:#fff;">
    <van-nav-bar
      :title="$t('m.td_span0')"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content">
      <div style="padding:0 10px;">
        <div class="signIn_btn" style="position: relative;">
          <div
            v-if="pid != 0"
            style=" position: absolute;top:-40px;right:0;font-size:10px;color:#fff;"
          >
            <span
              style="width: 80px;display: inline-block;line-height:30px;border-radius:6px;text-align:center;background: var(--bg-color);color:#fff;font-size:13px;"
              @click="dianji(pid)"
              >上级会员</span
            >
          </div>
          <div class="discolor" style="display:flex;height: 45px;">
            <img
              style="position: relative;top:-25px; width: 70px;height: 70px;border-radius:35px;border:4px solid #fff;"
              src="../../assets/images/new/user-list.png"
              alt=""
            />
            <span
              style="margin-left:12px;font-weight:bold;font-size:16px;margin-top:10px;"
            >
              {{
                userInfo.realname ? userInfo.realname : userInfo.username
              }}</span
            >
          </div>
          <div style="display:flex;align-items:center;padding:20px;">
            <div style="text-align:center;flex:1;">
              <p style="font-size:12px;margin-bottom:4px;">
                {{ $t("m.jy_span1") }}
              </p>
              <p style="font-size:16px;color:var(--bg-color);font-weight:blod;">
                {{ userInfo.tmoney }}
              </p>
            </div>
            <div style="text-align:center;flex:1;">
              <p style="font-size:12px;margin-bottom:4px;">
                {{ $t("m.jy_span3") }}
              </p>
              <p style="font-size:16px;color:var(--bg-color);font-weight:blod;">
                {{ userInfo.tadditional }}
              </p>
            </div>
            <div style="text-align:center;flex:1;">
              <p style="font-size:12px;margin-bottom:4px;">
                {{ $t("m.syicon2") }}
              </p>
              <p style="font-size:16px;color:var(--bg-color);font-weight:blod;">
                {{ userInfo.level }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 签到列表 -->
      <div class="signIn_list">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('m.gengduo')"
          @load="onLoad"
        >
          <div
            class="item"
            v-for="(item, index) in signInList"
            :key="index"
            @click="dianji(item.id)"
          >
            <img
              :src="imgs[index % 6]"
              style="width: 32px;height: 32px;border-radius:16px; margin-right:15px;"
              alt=""
            />
            <div class="divs" style="flex:1;">
              <div style="display:flex;align-items:center;margin-bottom:10px;">
                <div
                  style="font-size:14px;width: 66%; display:flex;align-items:center;"
                >
                  <span style="width: 50%;">{{
                    item.realname ? item.realname : "匿名用户"
                  }}</span>
                  <span style="color:#666;font-size:11px;width: 50%;">{{
                    item.is_auth == 1 ? "已实名认证" : "未实名认证"
                  }}</span>
                </div>
                <img
                  :src="imgs1[item.level]"
                  style="width: 20px;height: 20px;margin-left:0px;"
                  alt=""
                />
              </div>
              <div style="display:flex;align-items:center;color:#333;">
                <div style="width: 33%;">
                  <p style="font-size:13px;">会员等级</p>
                  <p
                    style="font-size:15px;font-weight:blod;color:var(--bg-color);line-height:26px;"
                  >
                    {{ item.level == 0 ? "普通用户" : "VIP" + item.level }}
                  </p>
                </div>
                <div style="width: 33%;">
                  <p style="font-size:13px;">累计充值</p>
                  <p
                    style="font-size:18px;font-weight:blod;color:var(--bg-color);"
                  >
                    {{ item.recharges }}
                  </p>
                </div>
                <div style="width: 33%;">
                  <p style="font-size:13px;">累计提现</p>
                  <p
                    style="font-size:18px;font-weight:blod;color:var(--bg-color);"
                  >
                    {{ item.withdraws }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div style="height: 1rem;"></div>
  </div>
</template>

<script>
import { getMyUserInfo } from "@api/user";
import request from "@utils/request";
export default {
  name: "",
  data() {
    return {
      userInfo: {},
      imgs: [
        require("../../assets/images/yhk/head1.png"),
        require("../../assets/images/yhk/head4.png"),
        require("../../assets/images/yhk/head5.png"),
        require("../../assets/images/yhk/head6.png"),
        require("../../assets/images/yhk/head2.png"),
        require("../../assets/images/yhk/head3.png")
      ],
      imgs1: [
        require("../../assets/images/yhk/vip0.png"),
        require("../../assets/images/yhk/vip1.png"),
        require("../../assets/images/yhk/vip2.png"),
        require("../../assets/images/yhk/vip3.png"),
        require("../../assets/images/yhk/vip4.png"),
        require("../../assets/images/yhk/vip5.png"),
        require("../../assets/images/yhk/vip6.png"),
        require("../../assets/images/yhk/vip7.png"),
        require("../../assets/images/yhk/vip8.png"),
        require("../../assets/images/yhk/vip9.png")
      ],

      signInList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 0,
      ids: "",
      upids: "",
      pid: ""
    };
  },
  created() {
    let that = this;
    setTimeout(() => {
      getMyUserInfo().then(res => {
        that.userInfo = res.data.data;
      });
    }, 1000);
  },
  methods: {
    dianji(e) {
      this.page = 0;
      this.upids = this.ids = e;
      this.signInList = [];
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      this.loading = true;
      this.onLoad();
    },
    async onLoad() {
      this.page = this.page + 1;
      let _this = this;
      request
        .post(
          "/user/team/team",
          { page: _this.page, uid: _this.ids },
          { login: true }
        )
        .then(res => {
          console.log("日利宝列表数据");
          console.log(res);
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          this.pid = res.data.data.pid;
          for (var i = 0; i < res.data.data.users.length; i++) {
            this.signInList.push(res.data.data.users[i]);
          }
          this.loading = false;
          if (res.data.data.users.length < 10) {
            this.finished = true;
          }
        })
        .catch(err => {
          console.log(err);
          this.$dialog.error(err.response.data.msg);
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  components: {}
};
</script>

<style scoped lang="less">
html,
body {
  background: #fff !important;
}
.discolor:active {
  opacity: 0.3 !important;
}
.signIn /deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: rgba(0, 0, 0, 0);
}
.signIn /deep/ .van-nav-bar__title {
  color: #fff;
}
.signIn /deep/ .van-icon {
  color: #fff;
}
.signIn {
  .content {
    font-weight: bold;
    color: #000;
    margin-top: -46px;
    padding: 0 12px;
    background-image: url(../../assets/images/user_bank.png);
    background-repeat: no-repeat;
    background-size: 100% 175px;
    padding-top: 105px;
    .signIn_title {
      margin: 25px 0;
    }
    .signIn_btn {
      background: #fff;
      box-shadow: 0px 0px 6px #eaeaea;
      border-radius: 10px;
    }
    .sigIn_list_title {
      margin: 20px 0 5px;
    }
    .signIn_list {
      margin-top: 10px;
      .item {
        display: flex;
        padding: 15px 0px 10px 10px;
        border-bottom: 1px solid #f2f2f2;
      }
    }
    .finish_text {
      padding: 10px 0;
      font-size: 12px;
      color: #666;
      text-align: center;
    }
  }
}
</style>
